"use client";

import type { MultiSelectStepInput } from "./form-types";
import type { StepInputRendererProps } from "./StepInputRenderer";

import { MultiSelectInputInner } from "./MultiSelectInputInner";
import { useTrackLeadFormEvent } from "./useTrackLeadFormEvent";

function isMultiSelectInput(
  input: StepInputRendererProps["input"],
): input is MultiSelectStepInput & {
  options: NonNullable<MultiSelectStepInput["options"]>;
} {
  return (
    input._type === "multiSelectInput" &&
    Array.isArray((input as MultiSelectStepInput).options)
  );
}

function MultiSelectInput({
  input,
  onContinue,
  errors,
  hideContinueButton,
  onFieldChange,
  stepName,
  heroVariantStyles,
}: StepInputRendererProps) {
  const trackLeadForm = useTrackLeadFormEvent();

  if (!isMultiSelectInput(input)) {
    return null;
  }

  const { fieldName } = input;

  return (
    <MultiSelectInputInner
      errors={errors}
      heroVariantStyles={heroVariantStyles}
      input={input}
      onContinue={
        hideContinueButton
          ? undefined
          : (selectedOptions) => {
              if (stepName && fieldName) {
                trackLeadForm?.leadFormStep({
                  stepName,
                  userSelection: { [fieldName]: selectedOptions },
                });
              }
              onContinue();
            }
      }
      onFieldChange={onFieldChange}
    />
  );
}

export { MultiSelectInput };
